import { css } from '@emotion/react';

export const toastShow = css`
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
`;

export const toastHide = css`
  visibility: hidden;
  opacity: 0;
  transform: translateY(-4px);
`;

const colorStyles = {
  success: css`
    background-color: var(--green-400);
  `,
  warning: css`
    background-color: var(--yellow-700);
  `,
  general: css`
    background-color: var(--gray-600);
  `,
  error: css`
    background-color: var(--red-500);
  `,
};

const positionStyles = {
  bottom: css`
    left: 50%;
    bottom: 16px;
    transform: translateX(-50%) !important;
  `,
  top: css`
    top: 32px;
    left: 50%;
    transform: translateX(-50%) !important;
  `,
};
export const container = (
  color: 'success' | 'warning' | 'general' | 'error',
  position: 'bottom' | 'top',
  width: string
) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${width};
  position: fixed;
  ${positionStyles[position]};
  padding: 14px 16px 16px 14px;
  ${colorStyles[color]};
  box-shadow: 0 4px 8px 0 rgba(33, 37, 41, 0.1);
  color: white;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.4px;
  white-space: pre-wrap;
  border-radius: 4px;
  text-align: left;
  transition: all 0.15s ease;
  z-index: var(--z-toast);
`;

export const spinner = css`
  margin-right: 4px;
`;

export const getBottomSafeAreaMargin = (bottomMargin?: number) => css`
  margin-bottom: calc(constant(safe-area-inset-bottom) + ${bottomMargin || 0}px);
  margin-bottom: calc(env(safe-area-inset-bottom) + ${bottomMargin || 0}px);
`;

export default {
  toastShow,
  toastHide,
  container,
  spinner,
  getBottomSafeAreaMargin,
};
